// src/components/NotificationActionsListener.jsx

'use client';

import { useEffect } from 'react';

export default function NotificationActionsListener({ onAccept, onDecline }) {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    function onMessage(event) {
      const { data } = event;
      if (data?.type === 'notification-action') {
        if (data.action === 'accept') {
          onAccept();
        } else if (data.action === 'decline') {
          onDecline();
        }
      }
    }

    navigator.serviceWorker.addEventListener('message', onMessage);

    // eslint-disable-next-line consistent-return
    return () => {
      navigator.serviceWorker.removeEventListener('message', onMessage);
    };
  }, [onAccept, onDecline]);

  return null;
}
